import PropTypes from 'prop-types';
import { useFormContext } from 'react-hook-form';

import { SECTION_KEYS } from '../../constants/sections';
import { useCheckout } from '../../hooks/useCheckout';
import CheckoutCard from '../CheckoutCard';
import EditView from './EditView';
import SummaryView from './SummaryView';

function ContactInfoCard({ hideEdit, sectionNumber }) {
  const { formState } = useFormContext();
  const { validSections } = useCheckout();

  const sectionKey = SECTION_KEYS.CONTACT_INFO;
  const isValid = validSections[sectionKey];

  const showSubtitle = !isValid && !formState.isSubmitted;

  // TODO: translate strings
  const title = 'Owner';
  const subtitle = showSubtitle ? "We couldn't find all the owner details." : null;

  return (
    <CheckoutCard
      hideEdit={hideEdit}
      sectionKey={sectionKey}
      sectionNumber={sectionNumber}
      subtitle={subtitle}
      title={title}
    >
      <CheckoutCard.Summary>
        <SummaryView sectionKey={sectionKey} />
      </CheckoutCard.Summary>
      <CheckoutCard.Edit>
        <EditView sectionKey={sectionKey} />
      </CheckoutCard.Edit>
    </CheckoutCard>
  );
}

ContactInfoCard.propTypes = {
  hideEdit: PropTypes.bool,
  sectionNumber: PropTypes.number.isRequired
};

export default ContactInfoCard;
